// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__t18bo","title":"Card_title__AB9Dz"};